import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {UIArtefakt, UIArtefaktGruppe, uniqueKey} from '../../models/uiArtefakt';
import {ShellConfigService} from '../../services/shell-config.service';
import {UIAusrichtung} from '../../models/uiAusrichtung';
import {UIDarstellungsart} from '../../models/uiDarstellungsart';
import {EventService} from '../../services/event.service';

@Component({
    selector: 'lv-gruppe',
    templateUrl: './gruppe.component.html',
    styleUrls: ['./gruppe.component.scss'],
    standalone: false
})
export class GruppeComponent implements OnInit, AfterViewInit {

  @Input()
  public uiArtefakt: UIArtefaktGruppe;

  public uiAusrichtung: UIAusrichtung;
  public expansionPanel: boolean = false;

  constructor(private _shellConfigService: ShellConfigService, public eventService: EventService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
  }

  ngOnInit(): void {
    this.expansionPanel = this.uiArtefakt?.UIArtefaktGruppeComponent === 'Erweiterungspanel';
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    if (!this.uiAusrichtung) {
      throw new Error('Die UIAusrichtung ist nicht gesetzt, bitte im Designer die UIParameter im UIVorgang setzen.');
    }
  }

  public trackByFn(index: number, item: UIArtefakt) {
    if (item['Darstellungsart'] === UIDarstellungsart.DISABLED) {
      return !item.recreateComponent ? uniqueKey(item) + item.WertEingabe : uniqueKey(item) + item.WertEingabe + '-recreate';
    }
    return !item.recreateComponent ? uniqueKey(item) : uniqueKey(item) + '-recreate';
  }
}
